/**
 * TableBody Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * TableBody Class
 */
class TableBody extends Component {
    static propTypes = {
        children: childrenPropType,
    };

    static defaultProps = {
        children: null,
    };

    /**
     * Render the table.
     *
     * @returns {React.node}
     */
    render() {
        const { children } = this.props;

        return (
            <tbody>
                {children}
            </tbody>
        );
    }
}

export default TableBody;
